import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// React Router doesn't reset scroll on client-side navigation, so a new page
// (e.g. a recipe opened from a scrolled-down list) inherits the previous scroll.
// Reset to the top on forward navigations (PUSH/REPLACE); leave POP (Back/Forward)
// alone so the browser restores your previous position in the list.
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== "POP") window.scrollTo(0, 0);
  }, [pathname, navType]);

  return null;
}
